import { cssVar } from '@toeverything/theme';

export default function TopSvg() {
  return (
    <svg
      width="400"
      height="220"
      viewBox="0 0 400 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5877_92351)">
        <g filter="url(#filter0_d_5877_92351)">
          <rect
            y="0.0753174"
            width="400"
            height="220"
            fill={cssVar('backgroundPrimaryColor')}
          />
        </g>
        <rect
          x="16"
          y="10"
          width="64"
          height="32"
          rx="12"
          fill={cssVar('backgroundSecondaryColor')}
        />
        <g filter="url(#filter1_d_5877_92351)">
          <rect
            x="20"
            y="14"
            width="24"
            height="24"
            rx="8"
            fill={cssVar('backgroundPrimaryColor')}
            shapeRendering="crispEdges"
          />
          <g clipPath="url(#clip1_5877_92351)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M27.8334 18.7084C26.5677 18.7084 25.5417 19.7344 25.5417 21V31C25.5417 32.2657 26.5677 33.2917 27.8334 33.2917H36.1667C37.4323 33.2917 38.4584 32.2657 38.4584 31V21C38.4584 19.7344 37.4323 18.7084 36.1667 18.7084H27.8334ZM26.7917 21C26.7917 20.4247 27.2581 19.9584 27.8334 19.9584H36.1667C36.742 19.9584 37.2084 20.4247 37.2084 21V31C37.2084 31.5753 36.742 32.0417 36.1667 32.0417H27.8334C27.2581 32.0417 26.7917 31.5753 26.7917 31V21ZM29.5 22.0417C29.1548 22.0417 28.875 22.3215 28.875 22.6667C28.875 23.0119 29.1548 23.2917 29.5 23.2917H32.4167C32.7619 23.2917 33.0417 23.0119 33.0417 22.6667C33.0417 22.3215 32.7619 22.0417 32.4167 22.0417H29.5ZM28.875 25.5834C28.875 25.2382 29.1548 24.9584 29.5 24.9584H34.5C34.8452 24.9584 35.125 25.2382 35.125 25.5834C35.125 25.9286 34.8452 26.2084 34.5 26.2084H29.5C29.1548 26.2084 28.875 25.9286 28.875 25.5834ZM29.5 27.875C29.1548 27.875 28.875 28.1549 28.875 28.5C28.875 28.8452 29.1548 29.125 29.5 29.125H33.6667C34.0119 29.125 34.2917 28.8452 34.2917 28.5C34.2917 28.1549 34.0119 27.875 33.6667 27.875H29.5Z"
              fill={cssVar('primaryColor')}
            />
          </g>
        </g>
        <g clipPath="url(#clip2_5877_92351)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M59.9735 19.9584C59.1137 19.9584 58.4167 20.6554 58.4167 21.5152C58.4167 22.3751 59.1137 23.0721 59.9735 23.0721C60.8334 23.0721 61.5304 22.3751 61.5304 21.5152C61.5304 20.6554 60.8334 19.9584 59.9735 19.9584ZM57.1667 21.5152C57.1667 19.965 58.4234 18.7084 59.9735 18.7084C61.4604 18.7084 62.6772 19.8644 62.7742 21.3266C63.4762 21.3273 64.1503 21.3383 64.8517 21.5077C65.6295 21.6956 66.4061 22.0674 67.3305 22.7607L67.3475 22.7734L67.3636 22.7873C68.669 23.9126 69.3224 25.7317 69.326 27.4358H70.7084C71.0536 27.4358 71.3334 27.7156 71.3334 28.0608V31.9881C71.3334 32.3333 71.0536 32.6131 70.7084 32.6131H66.781C66.4359 32.6131 66.156 32.3333 66.156 31.9881V28.0608C66.156 27.7156 66.4359 27.4358 66.781 27.4358H68.076C68.0724 26.0148 67.5229 24.5853 66.563 23.7476C65.7506 23.1409 65.1313 22.8612 64.5582 22.7227C63.9652 22.5795 63.3858 22.5766 62.5918 22.5766V22.5289C62.2585 23.3891 61.5135 24.0442 60.5986 24.2523V27.5056C61.8479 27.7898 62.7804 28.9073 62.7804 30.2427C62.7804 31.7928 61.5237 33.0495 59.9735 33.0495C58.4234 33.0495 57.1667 31.7928 57.1667 30.2427C57.1667 28.9073 58.0992 27.7897 59.3486 27.5056V24.2523C58.0992 23.9682 57.1667 22.8506 57.1667 21.5152ZM59.9735 28.6858C59.1137 28.6858 58.4167 29.3828 58.4167 30.2427C58.4167 31.1025 59.1137 31.7995 59.9735 31.7995C60.8334 31.7995 61.5304 31.1025 61.5304 30.2427C61.5304 29.3828 60.8334 28.6858 59.9735 28.6858ZM67.406 31.3631V28.6858H70.0834V31.3631H67.406Z"
            fill={cssVar('iconColor')}
          />
        </g>
        <rect
          x="92"
          y="10"
          width="128.528"
          height="32"
          rx="12"
          fill={cssVar('backgroundSecondaryColor')}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M238.998 23.4697C239.29 23.1768 239.765 23.1768 240.058 23.4697L244.174 27.5858C244.37 27.781 244.686 27.781 244.881 27.5858L248.998 23.4697C249.29 23.1768 249.765 23.1768 250.058 23.4697C250.351 23.7626 250.351 24.2374 250.058 24.5303L245.942 28.6464C245.161 29.4275 243.895 29.4275 243.114 28.6464L238.998 24.5303C238.705 24.2374 238.705 23.7626 238.998 23.4697Z"
          fill={cssVar('iconColor')}
        />
        <g filter="url(#filter2_di_5877_92351)">
          <rect
            x="107.402"
            y="32.1934"
            width="211.325"
            height="221.308"
            rx="8"
            stroke={cssVar('borderColor')}
            fill={cssVar('backgroundOverlayPanelColor')}
          />
        </g>
        <rect
          x="120"
          y="49"
          width="183.726"
          height="18"
          rx="4"
          fill={cssVar('backgroundSecondaryColor')}
        />
        <rect
          x="120"
          y="77"
          width="183.726"
          height="18"
          rx="4"
          fill={cssVar('backgroundSecondaryColor')}
        />
        <rect
          x="120"
          y="105"
          width="183.726"
          height="18"
          rx="4"
          fill={cssVar('backgroundSecondaryColor')}
        />
        <rect
          x="120"
          y="133"
          width="183.726"
          height="18"
          rx="4"
          fill={cssVar('backgroundSecondaryColor')}
        />
        <g clipPath="url(#clip3_5877_92351)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M137.973 171.496L137.972 171.497L136.958 172.412H138.25C138.595 172.412 138.875 172.692 138.875 173.037C138.875 173.382 138.595 173.662 138.25 173.662H135.333C134.988 173.662 134.708 173.382 134.708 173.037V170.167C134.708 169.822 134.988 169.542 135.333 169.542C135.678 169.542 135.958 169.822 135.958 170.167V171.631L137.139 170.565C138.428 169.411 140.133 168.708 142 168.708C146.027 168.708 149.292 171.973 149.292 176C149.292 180.027 146.027 183.292 142 183.292C138.529 183.292 135.626 180.867 134.889 177.62C134.813 177.283 135.024 176.948 135.36 176.872C135.697 176.796 136.032 177.007 136.108 177.343C136.719 180.034 139.125 182.042 142 182.042C145.337 182.042 148.042 179.337 148.042 176C148.042 172.663 145.337 169.958 142 169.958C140.453 169.958 139.043 170.539 137.973 171.496Z"
            fill={cssVar('iconColor')}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M142 171.625C142.345 171.625 142.625 171.905 142.625 172.25V175.741L144.942 178.058C145.186 178.302 145.186 178.698 144.942 178.942C144.698 179.186 144.302 179.186 144.058 178.942L141.582 176.466C141.45 176.334 141.375 176.153 141.375 175.966V172.25C141.375 171.905 141.655 171.625 142 171.625Z"
            fill={cssVar('iconColor')}
          />
        </g>
        <path
          d="M161.651 170.818L164.673 179.389H164.793L167.815 170.818H169.108L165.369 181H164.097L160.358 170.818H161.651ZM170.535 181V173.364H171.708V181H170.535ZM171.131 172.091C170.903 172.091 170.705 172.013 170.54 171.857C170.377 171.701 170.296 171.514 170.296 171.295C170.296 171.077 170.377 170.889 170.54 170.734C170.705 170.578 170.903 170.5 171.131 170.5C171.36 170.5 171.556 170.578 171.718 170.734C171.884 170.889 171.967 171.077 171.967 171.295C171.967 171.514 171.884 171.701 171.718 171.857C171.556 172.013 171.36 172.091 171.131 172.091ZM177.059 181.159C176.323 181.159 175.688 180.997 175.155 180.672C174.624 180.344 174.215 179.886 173.927 179.3C173.642 178.71 173.499 178.024 173.499 177.241C173.499 176.459 173.642 175.77 173.927 175.173C174.215 174.573 174.616 174.106 175.13 173.771C175.647 173.433 176.25 173.264 176.939 173.264C177.337 173.264 177.73 173.33 178.118 173.463C178.506 173.596 178.858 173.811 179.177 174.109C179.495 174.404 179.748 174.795 179.937 175.283C180.126 175.77 180.221 176.37 180.221 177.082V177.58H174.334V176.565H179.028C179.028 176.134 178.941 175.75 178.769 175.412C178.6 175.074 178.358 174.807 178.043 174.612C177.732 174.416 177.364 174.318 176.939 174.318C176.472 174.318 176.068 174.434 175.726 174.666C175.388 174.895 175.128 175.193 174.946 175.561C174.764 175.929 174.672 176.323 174.672 176.744V177.42C174.672 177.997 174.772 178.486 174.971 178.887C175.173 179.285 175.453 179.588 175.811 179.797C176.169 180.002 176.585 180.105 177.059 180.105C177.367 180.105 177.645 180.062 177.894 179.976C178.146 179.886 178.363 179.754 178.545 179.578C178.728 179.399 178.868 179.177 178.968 178.912L180.101 179.23C179.982 179.615 179.782 179.953 179.5 180.244C179.218 180.533 178.87 180.758 178.456 180.92C178.041 181.08 177.576 181.159 177.059 181.159ZM183.736 181L181.409 173.364H182.642L184.292 179.21H184.372L186.003 173.364H187.256L188.866 179.19H188.946L190.596 173.364H191.829L189.503 181H188.349L186.679 175.134H186.559L184.889 181H183.736ZM197.477 181V170.818H198.71V175.352H204.139V170.818H205.372V181H204.139V176.446H198.71V181H197.477ZM207.681 181V173.364H208.855V181H207.681ZM208.278 172.091C208.049 172.091 207.852 172.013 207.686 171.857C207.524 171.701 207.443 171.514 207.443 171.295C207.443 171.077 207.524 170.889 207.686 170.734C207.852 170.578 208.049 170.5 208.278 170.5C208.507 170.5 208.702 170.578 208.865 170.734C209.03 170.889 209.113 171.077 209.113 171.295C209.113 171.514 209.03 171.701 208.865 171.857C208.702 172.013 208.507 172.091 208.278 172.091ZM216.413 175.074L215.359 175.372C215.292 175.196 215.195 175.026 215.065 174.86C214.939 174.691 214.767 174.552 214.548 174.442C214.33 174.333 214.049 174.278 213.708 174.278C213.241 174.278 212.851 174.386 212.54 174.602C212.232 174.814 212.077 175.084 212.077 175.412C212.077 175.704 212.183 175.934 212.396 176.103C212.608 176.272 212.939 176.413 213.39 176.526L214.523 176.804C215.206 176.97 215.715 177.223 216.05 177.565C216.384 177.903 216.552 178.339 216.552 178.872C216.552 179.31 216.426 179.701 216.174 180.045C215.925 180.39 215.577 180.662 215.13 180.861C214.683 181.06 214.162 181.159 213.569 181.159C212.79 181.159 212.145 180.99 211.635 180.652C211.125 180.314 210.801 179.82 210.665 179.17L211.779 178.892C211.885 179.303 212.086 179.611 212.381 179.817C212.679 180.022 213.068 180.125 213.549 180.125C214.096 180.125 214.53 180.009 214.852 179.777C215.176 179.542 215.339 179.26 215.339 178.932C215.339 178.667 215.246 178.445 215.06 178.266C214.875 178.083 214.59 177.947 214.205 177.858L212.933 177.56C212.233 177.394 211.719 177.137 211.391 176.789C211.067 176.438 210.904 175.999 210.904 175.472C210.904 175.041 211.025 174.66 211.267 174.328C211.512 173.997 211.845 173.737 212.266 173.548C212.691 173.359 213.171 173.264 213.708 173.264C214.464 173.264 215.057 173.43 215.488 173.761C215.922 174.093 216.23 174.53 216.413 175.074ZM221.639 173.364V174.358H217.682V173.364H221.639ZM218.835 171.534H220.008V178.812C220.008 179.144 220.056 179.393 220.153 179.558C220.252 179.721 220.378 179.83 220.53 179.886C220.686 179.939 220.85 179.966 221.023 179.966C221.152 179.966 221.258 179.959 221.341 179.946C221.424 179.929 221.49 179.916 221.54 179.906L221.778 180.96C221.699 180.99 221.588 181.02 221.445 181.05C221.303 181.083 221.122 181.099 220.903 181.099C220.572 181.099 220.247 181.028 219.929 180.886C219.614 180.743 219.352 180.526 219.143 180.234C218.938 179.943 218.835 179.575 218.835 179.131V171.534ZM226.424 181.159C225.735 181.159 225.13 180.995 224.61 180.667C224.093 180.339 223.688 179.88 223.396 179.29C223.108 178.7 222.964 178.01 222.964 177.222C222.964 176.426 223.108 175.732 223.396 175.138C223.688 174.545 224.093 174.085 224.61 173.756C225.13 173.428 225.735 173.264 226.424 173.264C227.114 173.264 227.717 173.428 228.234 173.756C228.754 174.085 229.159 174.545 229.447 175.138C229.739 175.732 229.884 176.426 229.884 177.222C229.884 178.01 229.739 178.7 229.447 179.29C229.159 179.88 228.754 180.339 228.234 180.667C227.717 180.995 227.114 181.159 226.424 181.159ZM226.424 180.105C226.948 180.105 227.379 179.971 227.717 179.702C228.055 179.434 228.305 179.081 228.468 178.643C228.63 178.206 228.711 177.732 228.711 177.222C228.711 176.711 228.63 176.236 228.468 175.795C228.305 175.354 228.055 174.998 227.717 174.726C227.379 174.454 226.948 174.318 226.424 174.318C225.901 174.318 225.47 174.454 225.132 174.726C224.794 174.998 224.543 175.354 224.381 175.795C224.218 176.236 224.137 176.711 224.137 177.222C224.137 177.732 224.218 178.206 224.381 178.643C224.543 179.081 224.794 179.434 225.132 179.702C225.47 179.971 225.901 180.105 226.424 180.105ZM231.675 181V173.364H232.809V174.517H232.888C233.028 174.139 233.28 173.833 233.644 173.597C234.009 173.362 234.42 173.244 234.877 173.244C234.963 173.244 235.071 173.246 235.2 173.249C235.33 173.253 235.427 173.258 235.494 173.264V174.457C235.454 174.447 235.363 174.433 235.22 174.413C235.081 174.389 234.933 174.378 234.778 174.378C234.406 174.378 234.075 174.456 233.783 174.612C233.495 174.764 233.266 174.976 233.097 175.248C232.932 175.516 232.849 175.823 232.849 176.168V181H231.675ZM237.873 183.864C237.674 183.864 237.496 183.847 237.341 183.814C237.185 183.784 237.077 183.754 237.017 183.724L237.316 182.69C237.601 182.763 237.853 182.79 238.071 182.77C238.29 182.75 238.484 182.652 238.653 182.477C238.825 182.304 238.983 182.024 239.125 181.636L239.344 181.04L236.52 173.364H237.793L239.901 179.449H239.98L242.088 173.364H243.361L240.12 182.114C239.974 182.508 239.793 182.835 239.578 183.093C239.362 183.355 239.112 183.549 238.827 183.675C238.545 183.801 238.227 183.864 237.873 183.864ZM249.424 170.818L252.447 179.389H252.566L255.589 170.818H256.881L253.143 181H251.87L248.131 170.818H249.424ZM260.799 181.159C260.063 181.159 259.429 180.997 258.895 180.672C258.365 180.344 257.955 179.886 257.667 179.3C257.382 178.71 257.239 178.024 257.239 177.241C257.239 176.459 257.382 175.77 257.667 175.173C257.955 174.573 258.356 174.106 258.87 173.771C259.387 173.433 259.99 173.264 260.68 173.264C261.077 173.264 261.47 173.33 261.858 173.463C262.246 173.596 262.599 173.811 262.917 174.109C263.235 174.404 263.489 174.795 263.678 175.283C263.866 175.77 263.961 176.37 263.961 177.082V177.58H258.075V176.565H262.768C262.768 176.134 262.682 175.75 262.509 175.412C262.34 175.074 262.098 174.807 261.783 174.612C261.472 174.416 261.104 174.318 260.68 174.318C260.212 174.318 259.808 174.434 259.467 174.666C259.129 174.895 258.868 175.193 258.686 175.561C258.504 175.929 258.413 176.323 258.413 176.744V177.42C258.413 177.997 258.512 178.486 258.711 178.887C258.913 179.285 259.193 179.588 259.551 179.797C259.909 180.002 260.325 180.105 260.799 180.105C261.107 180.105 261.386 180.062 261.634 179.976C261.886 179.886 262.103 179.754 262.286 179.578C262.468 179.399 262.609 179.177 262.708 178.912L263.842 179.23C263.722 179.615 263.522 179.953 263.24 180.244C262.958 180.533 262.61 180.758 262.196 180.92C261.782 181.08 261.316 181.159 260.799 181.159ZM265.746 181V173.364H266.879V174.517H266.959C267.098 174.139 267.35 173.833 267.714 173.597C268.079 173.362 268.49 173.244 268.947 173.244C269.034 173.244 269.141 173.246 269.271 173.249C269.4 173.253 269.498 173.258 269.564 173.264V174.457C269.524 174.447 269.433 174.433 269.29 174.413C269.151 174.389 269.004 174.378 268.848 174.378C268.477 174.378 268.145 174.456 267.854 174.612C267.565 174.764 267.337 174.976 267.168 175.248C267.002 175.516 266.919 175.823 266.919 176.168V181H265.746ZM276.364 175.074L275.31 175.372C275.244 175.196 275.146 175.026 275.017 174.86C274.891 174.691 274.718 174.552 274.499 174.442C274.281 174.333 274.001 174.278 273.659 174.278C273.192 174.278 272.802 174.386 272.491 174.602C272.183 174.814 272.029 175.084 272.029 175.412C272.029 175.704 272.135 175.934 272.347 176.103C272.559 176.272 272.89 176.413 273.341 176.526L274.475 176.804C275.157 176.97 275.666 177.223 276.001 177.565C276.336 177.903 276.503 178.339 276.503 178.872C276.503 179.31 276.377 179.701 276.125 180.045C275.877 180.39 275.529 180.662 275.081 180.861C274.634 181.06 274.113 181.159 273.52 181.159C272.741 181.159 272.097 180.99 271.586 180.652C271.076 180.314 270.753 179.82 270.617 179.17L271.73 178.892C271.836 179.303 272.037 179.611 272.332 179.817C272.63 180.022 273.02 180.125 273.5 180.125C274.047 180.125 274.481 180.009 274.803 179.777C275.128 179.542 275.29 179.26 275.29 178.932C275.29 178.667 275.197 178.445 275.012 178.266C274.826 178.083 274.541 177.947 274.156 177.858L272.884 177.56C272.184 177.394 271.671 177.137 271.343 176.789C271.018 176.438 270.855 175.999 270.855 175.472C270.855 175.041 270.976 174.66 271.218 174.328C271.463 173.997 271.797 173.737 272.218 173.548C272.642 173.359 273.122 173.264 273.659 173.264C274.415 173.264 275.008 173.43 275.439 173.761C275.873 174.093 276.182 174.53 276.364 175.074ZM278.269 181V173.364H279.442V181H278.269ZM278.866 172.091C278.637 172.091 278.44 172.013 278.274 171.857C278.112 171.701 278.031 171.514 278.031 171.295C278.031 171.077 278.112 170.889 278.274 170.734C278.44 170.578 278.637 170.5 278.866 170.5C279.094 170.5 279.29 170.578 279.452 170.734C279.618 170.889 279.701 171.077 279.701 171.295C279.701 171.514 279.618 171.701 279.452 171.857C279.29 172.013 279.094 172.091 278.866 172.091ZM284.694 181.159C284.004 181.159 283.399 180.995 282.879 180.667C282.362 180.339 281.958 179.88 281.666 179.29C281.378 178.7 281.233 178.01 281.233 177.222C281.233 176.426 281.378 175.732 281.666 175.138C281.958 174.545 282.362 174.085 282.879 173.756C283.399 173.428 284.004 173.264 284.694 173.264C285.383 173.264 285.986 173.428 286.503 173.756C287.024 174.085 287.428 174.545 287.716 175.138C288.008 175.732 288.154 176.426 288.154 177.222C288.154 178.01 288.008 178.7 287.716 179.29C287.428 179.88 287.024 180.339 286.503 180.667C285.986 180.995 285.383 181.159 284.694 181.159ZM284.694 180.105C285.217 180.105 285.648 179.971 285.986 179.702C286.324 179.434 286.575 179.081 286.737 178.643C286.899 178.206 286.981 177.732 286.981 177.222C286.981 176.711 286.899 176.236 286.737 175.795C286.575 175.354 286.324 174.998 285.986 174.726C285.648 174.454 285.217 174.318 284.694 174.318C284.17 174.318 283.739 174.454 283.401 174.726C283.063 174.998 282.813 175.354 282.65 175.795C282.488 176.236 282.407 176.711 282.407 177.222C282.407 177.732 282.488 178.206 282.65 178.643C282.813 179.081 283.063 179.434 283.401 179.702C283.739 179.971 284.17 180.105 284.694 180.105ZM291.118 176.406V181H289.945V173.364H291.078V174.557H291.178C291.357 174.169 291.629 173.857 291.993 173.622C292.358 173.384 292.828 173.264 293.405 173.264C293.922 173.264 294.375 173.37 294.762 173.582C295.15 173.791 295.452 174.109 295.667 174.537C295.883 174.961 295.99 175.498 295.99 176.148V181H294.817V176.227C294.817 175.627 294.661 175.16 294.35 174.825C294.038 174.487 293.611 174.318 293.067 174.318C292.693 174.318 292.358 174.399 292.063 174.562C291.771 174.724 291.541 174.961 291.372 175.273C291.203 175.584 291.118 175.962 291.118 176.406Z"
          fill={cssVar('textPrimaryColor')}
        />
        <rect
          x="120"
          y="201"
          width="183.726"
          height="18"
          rx="4"
          fill={cssVar('backgroundSecondaryColor')}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_5877_92351"
          x="-7.65691"
          y="-7.5816"
          width="415.314"
          height="235.314"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="3.82846" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5877_92351"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5877_92351"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5877_92351"
          x="16"
          y="10"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5877_92351"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5877_92351"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_di_5877_92351"
          x="95.4016"
          y="20.1934"
          width="235.325"
          height="245.308"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="6" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.258824 0 0 0 0 0.254902 0 0 0 0 0.286275 0 0 0 0.14 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5877_92351"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5877_92351"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.5"
            operator="erode"
            in="SourceAlpha"
            result="effect2_innerShadow_5877_92351"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_5877_92351"
          />
        </filter>
        <clipPath id="clip0_5877_92351">
          <rect width="400" height="220" fill="white" />
        </clipPath>
        <clipPath id="clip1_5877_92351">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(22 16)"
          />
        </clipPath>
        <clipPath id="clip2_5877_92351">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(54 16)"
          />
        </clipPath>
        <clipPath id="clip3_5877_92351">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(132 166)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
